import { render, staticRenderFns } from "./ExamPackagePaper.vue?vue&type=template&id=7ac651bd&scoped=true"
import script from "./ExamPackagePaper.vue?vue&type=script&lang=js"
export * from "./ExamPackagePaper.vue?vue&type=script&lang=js"
import style0 from "./ExamPackagePaper.vue?vue&type=style&index=0&id=7ac651bd&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7ac651bd",
  null
  
)

export default component.exports